<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { NCard, NProgress, NText } from 'naive-ui'
import { useProjectLoadingStore } from '@/store/projectLoading'

const store = useProjectLoadingStore()
const { active, progress, status, mode } = storeToRefs(store)
</script>

<template>
  <Teleport to="body">
    <div
      v-if="active && mode === 'overlay'"
      class="load-overlay"
      role="alertdialog"
      aria-busy="true"
      :aria-label="status"
    >
      <n-card class="load-card" size="small">
        <n-text class="load-title">{{ status }}</n-text>
        <n-progress
          type="line"
          :percentage="progress"
          :show-indicator="true"
          :height="10"
          :border-radius="6"
          processing
        />
      </n-card>
    </div>
  </Teleport>
</template>

<style scoped>
/* 加载遮罩需要压暗整个工具，避免浅色主题下突兀变白。 */
.load-overlay {
  position: fixed;
  inset: 0;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.45);
}

.load-card {
  width: min(360px, 92vw);
  background: var(--theme-bg-panel);
}

.load-title {
  display: block;
  margin-bottom: 14px;
  font-size: 15px;
  font-weight: 600;
}
</style>
